import { render, staticRenderFns } from "./org_course.vue?vue&type=template&id=4d7c6796&scoped=true"
import script from "./org_course.vue?vue&type=script&lang=js"
export * from "./org_course.vue?vue&type=script&lang=js"
import style0 from "./org_course.vue?vue&type=style&index=0&id=4d7c6796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c6796",
  null
  
)

export default component.exports